import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "mall-cart" }
const _hoisted_2 = { class: "mall-cart__shell" }
const _hoisted_3 = { class: "mall-cart__head" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mall-cart__head-actions" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "mall-cart__sets"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "mall-cart__sets-msg"
}
const _hoisted_10 = {
  key: 2,
  class: "mall-cart__sets-list"
}
const _hoisted_11 = { class: "mall-cart__sets-actions" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = {
  key: 3,
  class: "mall-cart__sets-empty"
}
const _hoisted_16 = {
  key: 1,
  class: "mall-cart__loading",
  "aria-busy": "true"
}
const _hoisted_17 = {
  key: 2,
  class: "mall-cart__empty"
}
const _hoisted_18 = { class: "mall-cart__empty-icon" }
const _hoisted_19 = {
  key: 3,
  class: "mall-cart__layout"
}
const _hoisted_20 = { class: "mall-cart__main" }
const _hoisted_21 = {
  key: 0,
  class: "mall-cart__alert"
}
const _hoisted_22 = { class: "mall-cart__select-bar" }
const _hoisted_23 = { class: "mall-cart__check" }
const _hoisted_24 = ["checked"]
const _hoisted_25 = { class: "mall-cart__select-count" }
const _hoisted_26 = { class: "mall-cart__select-actions" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "mall-cart__list" }
const _hoisted_30 = { class: "mall-cart__check mall-cart__check--item" }
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = {
  key: 1,
  class: "mall-cart__thumb-fallback"
}
const _hoisted_34 = { class: "mall-cart__body" }
const _hoisted_35 = { class: "mall-cart__body-top" }
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = { class: "mall-cart__meta" }
const _hoisted_38 = {
  key: 1,
  class: "mall-cart__unit-label"
}
const _hoisted_39 = {
  key: 2,
  class: "mall-cart__unit-label"
}
const _hoisted_40 = {
  key: 3,
  class: "mall-cart__option"
}
const _hoisted_41 = ["disabled", "onClick"]
const _hoisted_42 = {
  key: 0,
  class: "mall-cart__opt-panel"
}
const _hoisted_43 = ["for"]
const _hoisted_44 = ["id", "onUpdate:modelValue"]
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "mall-cart__opt-actions" }
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = ["disabled", "onClick"]
const _hoisted_49 = {
  key: 1,
  class: "mall-cart__warn"
}
const _hoisted_50 = {
  key: 2,
  class: "mall-cart__warn"
}
const _hoisted_51 = {
  key: 3,
  class: "mall-cart__warn"
}
const _hoisted_52 = { class: "mall-cart__row" }
const _hoisted_53 = { class: "mall-cart__summary" }
const _hoisted_54 = { class: "mall-cart__summary-pick" }
const _hoisted_55 = { class: "mall-cart__payable" }
const _hoisted_56 = {
  key: 1,
  type: "button",
  class: "mall-cart__checkout is-disabled",
  disabled: ""
}
const _hoisted_57 = { class: "mall-cart__hint" }
const _hoisted_58 = {
  key: 0,
  class: "mall-cart__undo",
  role: "status"
}

import { computed, onMounted, reactive, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import QtyStepper from '@/components/mall/QtyStepper.vue'
import MallOrderPackMark from '@/components/mall/MallOrderPackMark.vue'
import {
  createCartSet,
  deleteCartSet,
  fetchCartSets,
  loadCartSet,
  type MallCartSet,
} from '@/api/mallCartSet'
import { fetchLiveProduct } from '@/api/mallProduct'
import { useCart, type CartLine } from '@/composables/useCart'
import { useCartSelection } from '@/composables/useCartSelection'
import { useContentSnippets, SNIPPET_FALLBACKS } from '@/composables/useContentSnippets'
import { clearBuyNowKeys } from '@/composables/useBuyNowCheckout'
import { formatPrice, type MallProductOption } from '@/constants/mallProducts'
import { formatShippingFeeAmount, toShippingLine } from '@/utils/mallShipping'
import { calcOrderShippingFromLines, isOrderPack, sellUnitNoun } from '@/utils/mallSell'

interface OptionEditor {
  groups: Array<{ name: string; items: MallProductOption[] }>
  selected: Record<string, string>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MallCartPage',
  setup(__props) {

const {
  lines,
  isEmpty,
  loading,
  loaded,
  itemCount,
  productCount,
  setQty,
  setOption,
  addItem,
  removeItem,
  reload,
} = useCart()

const { selectedLines, allSelected, isSelected, toggle, selectAll } = useCartSelection()

const { loadSnippets, snippet } = useContentSnippets()
const shippingNote = computed(
  () => snippet('mall.cart.shipping_note') || SNIPPET_FALLBACKS['mall.cart.shipping_note'],
)

const busyKey = ref('')
const undoMessage = ref('')
let undoTimer: ReturnType<typeof setTimeout> | undefined
let lastRemoved:
  | { productId: string; qty: number; optionName?: string; optionExtra?: number }
  | null = null
const showSets = ref(false)
const cartSets = ref<MallCartSet[]>([])
const setName = ref('')
const setBusy = ref(false)
const setMessage = ref('')
const optionCache = new Map<string, MallProductOption[]>()

async function loadSets() {
  try {
    cartSets.value = await fetchCartSets()
  } catch {
    cartSets.value = []
  }
}

async function toggleSets() {
  showSets.value = !showSets.value
  if (showSets.value && !cartSets.value.length) {
    await loadSets()
  }
}

async function onSaveSet() {
  if (setBusy.value || isEmpty.value || !setName.value) return
  setBusy.value = true
  setMessage.value = ''
  try {
    await createCartSet({
      name: setName.value,
      items: lines.value.map((line) => ({
        productId: line.productId,
        qty: line.qty,
        optionName: line.optionName,
        optionExtra: line.optionExtra,
      })),
    })
    setName.value = ''
    setMessage.value = '자주 담는 목록에 저장했습니다.'
    await loadSets()
  } catch (error) {
    setMessage.value = error instanceof Error ? error.message : '저장에 실패했습니다.'
  } finally {
    setBusy.value = false
  }
}

async function onLoadSet(idx: number, replace: boolean) {
  if (setBusy.value) return
  if (replace && !window.confirm('현재 장바구니를 비우고 이 목록으로 바꿀까요?')) return

  setBusy.value = true
  setMessage.value = ''
  try {
    const result = await loadCartSet(idx, replace)
    await reload()
    setMessage.value = result.message || '장바구니에 담았습니다.'
  } catch (error) {
    setMessage.value = error instanceof Error ? error.message : '불러오기에 실패했습니다.'
  } finally {
    setBusy.value = false
  }
}

async function onDeleteSet(idx: number) {
  if (setBusy.value) return
  if (!window.confirm('이 목록을 삭제할까요?')) return
  setBusy.value = true
  try {
    await deleteCartSet(idx)
    await loadSets()
    setMessage.value = '목록을 삭제했습니다.'
  } catch (error) {
    setMessage.value = error instanceof Error ? error.message : '삭제에 실패했습니다.'
  } finally {
    setBusy.value = false
  }
}

onMounted(() => {
  void loadSnippets(['mall.cart.shipping_note'])
  /* 세트가 있을 때만 배지를 보여 주기 위해 조용히 불러 둔다 */
  loadSets()
})

const optionEditors = reactive<Record<string, OptionEditor>>({})

const hasIssue = computed(() =>
  lines.value.some((line) => line.soldOut || line.stockShort || line.priceChanged),
)
const issueLines = computed(() =>
  lines.value.filter((line) => line.soldOut || line.stockShort),
)
const selectedSubtotal = computed(() =>
  selectedLines.value.reduce((sum, line) => sum + line.lineTotal, 0),
)
const selectedListSubtotal = computed(() =>
  selectedLines.value.reduce((sum, line) => sum + line.listUnit * line.qty, 0),
)
const selectedShipping = computed(() =>
  calcOrderShippingFromLines(
    selectedLines.value.map((line) => toShippingLine(line.product, line.qty)),
  ),
)
const selectedShippingLabel = computed(() => formatShippingFeeAmount(selectedShipping.value))
const selectedPayable = computed(() => selectedSubtotal.value + selectedShipping.value)
const selectedHasBlocker = computed(() =>
  selectedLines.value.some((line) => line.soldOut || line.stockShort),
)
const canCheckoutSelected = computed(
  () => selectedLines.value.length > 0 && !selectedHasBlocker.value,
)
const checkoutDisabledLabel = computed(() => {
  if (!selectedLines.value.length) return '상품을 선택해 주세요'
  if (selectedHasBlocker.value) return '품절·재고 확인 후 주문'
  return '주문하기'
})

async function removeSelected() {
  if (!selectedLines.value.length || busyKey.value) return
  if (!window.confirm(`선택한 ${selectedLines.value.length}개 상품을 삭제할까요?`)) return
  busyKey.value = 'bulk'
  try {
    const keys = selectedLines.value.map((line) => line.key)
    for (const key of keys) {
      await removeItem(key)
    }
  } finally {
    busyKey.value = ''
  }
}

async function removeIssues() {
  if (!issueLines.value.length || busyKey.value) return
  busyKey.value = 'bulk'
  try {
    const keys = issueLines.value.map((line) => line.key)
    for (const key of keys) {
      await removeItem(key)
    }
  } finally {
    busyKey.value = ''
  }
}

function buildGroups(options: MallProductOption[]) {
  const groups = new Map<string, MallProductOption[]>()
  options.forEach((option) => {
    const groupName = option.group?.trim() || '구성'
    const list = groups.get(groupName) ?? []
    list.push(option)
    groups.set(groupName, list)
  })
  return [...groups.entries()].map(([name, items]) => ({ name, items }))
}

async function loadOptions(productId: string) {
  if (optionCache.has(productId)) {
    return optionCache.get(productId) || []
  }
  const detail = await fetchLiveProduct(productId)
  const options = (detail?.options || []).filter((option) => option.use)
  optionCache.set(productId, options)
  return options
}

async function toggleOptionEditor(line: CartLine) {
  if (optionEditors[line.key]) {
    delete optionEditors[line.key]
    return
  }

  busyKey.value = line.key
  try {
    const options = await loadOptions(line.productId)
    const groups = buildGroups(options)
    if (!groups.length) {
      window.alert('이 상품에는 변경할 옵션이 없습니다.')
      return
    }

    const selected: Record<string, string> = {}
    const parts = String(line.optionName || '')
      .split(' / ')
      .map((part) => part.trim())
      .filter(Boolean)

    groups.forEach((group, index) => {
      const fromLine = parts[index]
      const match = group.items.find((item) => item.name === fromLine)
      selected[group.name] = match?.name || group.items[0]?.name || ''
    })

    optionEditors[line.key] = { groups, selected }
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '옵션을 불러오지 못했습니다.')
  } finally {
    busyKey.value = ''
  }
}

async function saveOption(key: string) {
  const editor = optionEditors[key]
  if (!editor || busyKey.value) return

  const names = editor.groups.map((group) => editor.selected[group.name]).filter(Boolean)
  const extra = editor.groups.reduce((sum, group) => {
    const picked = group.items.find((item) => item.name === editor.selected[group.name])
    return sum + (picked?.extra || 0)
  }, 0)

  busyKey.value = key
  try {
    await setOption(key, { name: names.join(' / '), extra })
    delete optionEditors[key]
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '옵션을 바꾸지 못했습니다.')
  } finally {
    busyKey.value = ''
  }
}

async function onSetQty(key: string, qty: number) {
  if (busyKey.value) return
  busyKey.value = key
  try {
    await setQty(key, qty)
  } finally {
    busyKey.value = ''
  }
}

async function onRemove(key: string) {
  if (busyKey.value) return
  const line = lines.value.find((item) => item.key === key)
  if (!line) return
  busyKey.value = key
  try {
    lastRemoved = {
      productId: line.productId,
      qty: line.qty,
      optionName: line.optionName,
      optionExtra: line.optionExtra,
    }
    await removeItem(key)
    undoMessage.value = '장바구니에서 삭제했습니다.'
    window.clearTimeout(undoTimer)
    undoTimer = setTimeout(() => {
      undoMessage.value = ''
      lastRemoved = null
    }, 5000)
  } finally {
    busyKey.value = ''
  }
}

async function undoRemove() {
  if (!lastRemoved || busyKey.value) return
  const snapshot = lastRemoved
  busyKey.value = 'undo'
  try {
    await addItem(
      snapshot.productId,
      snapshot.qty,
      snapshot.optionName
        ? { name: snapshot.optionName, extra: snapshot.optionExtra || 0 }
        : undefined,
    )
    undoMessage.value = ''
    lastRemoved = null
    window.clearTimeout(undoTimer)
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '실행 취소에 실패했습니다.')
  } finally {
    busyKey.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, "장바구니", -1)),
          (_unref(loaded) && !_unref(isEmpty))
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(productCount)) + "종 · " + _toDisplayString(_unref(itemCount)) + "개", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/mall/cart/quote",
            class: "mall-cart__quote-link"
          }, {
            default: _withCtx(() => [
              _createVNode(AppIcon, {
                icon: "mdi-file-document-outline",
                size: 18
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" 견적서 ", -1))
            ]),
            _: 1
          }),
          (_unref(loaded))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["mall-cart__sets-toggle", { 'is-open': showSets.value }]),
                onClick: toggleSets
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-playlist-plus",
                  size: 18
                }),
                _cache[4] || (_cache[4] = _createTextVNode(" 자주 담는 목록 ", -1)),
                (cartSets.value.length)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_6, _toDisplayString(cartSets.value.length), 1))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      (showSets.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mall-cart__sets-head" }, [
              _createElementVNode("h2", null, "자주 담는 목록"),
              _createElementVNode("p", null, "반복 구매 세트를 저장해 두고 한 번에 담을 수 있습니다.")
            ], -1)),
            (!_unref(isEmpty))
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "mall-cart__sets-save",
                  onSubmit: _withModifiers(onSaveSet, ["prevent"])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setName).value = $event)),
                    type: "text",
                    maxlength: "60",
                    placeholder: "예: 월간 소모품 · 본원 기본세트",
                    required: ""
                  }, null, 512), [
                    [
                      _vModelText,
                      setName.value,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: setBusy.value
                  }, "현재 장바구니 저장", 8, _hoisted_8)
                ], 32))
              : _createCommentVNode("", true),
            (setMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(setMessage.value), 1))
              : _createCommentVNode("", true),
            (cartSets.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cartSets.value, (set) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: set.idx
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(set.name), 1),
                        _createElementVNode("span", null, _toDisplayString(set.itemCount) + "종", 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          disabled: setBusy.value,
                          onClick: ($event: any) => (onLoadSet(set.idx, false))
                        }, " 추가 담기 ", 8, _hoisted_12),
                        _createElementVNode("button", {
                          type: "button",
                          disabled: setBusy.value,
                          onClick: ($event: any) => (onLoadSet(set.idx, true))
                        }, " 이걸로 교체 ", 8, _hoisted_13),
                        _createElementVNode("button", {
                          type: "button",
                          class: "is-danger",
                          disabled: setBusy.value,
                          onClick: ($event: any) => (onDeleteSet(set.idx))
                        }, " 삭제 ", 8, _hoisted_14)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, "저장된 목록이 없습니다."))
          ]))
        : _createCommentVNode("", true),
      (!_unref(loaded) || _unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("span", { class: "mall-cart__spinner" }, null, -1),
            _createElementVNode("p", null, "장바구니를 불러오는 중입니다", -1)
          ]))]))
        : (_unref(isEmpty))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                _createVNode(AppIcon, {
                  icon: "mdi-cart-outline",
                  size: 40
                })
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("p", null, "장바구니가 비어 있습니다.", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("em", null, "원하시는 상품을 장바구니에 담아 주세요.", -1)),
              _createVNode(_component_router_link, {
                to: "/mall",
                class: "mall-cart__link"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("쇼핑계속하기", -1)
                ]))]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (hasIssue.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                      _createVNode(AppIcon, {
                        icon: "mdi-alert-outline",
                        size: 16
                      }),
                      _cache[10] || (_cache[10] = _createTextVNode(" 품절·재고 부족·가격 변동이 있는 상품이 있습니다. 주문 전에 확인해 주세요. ", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: _unref(allSelected),
                      onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(selectAll)(($event.target as HTMLInputElement).checked)))
                    }, null, 40, _hoisted_24),
                    _cache[11] || (_cache[11] = _createTextVNode(" 전체선택 ", -1))
                  ]),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(selectedLines).length) + " / " + _toDisplayString(_unref(lines).length) + "개 선택 ", 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "mall-cart__ghost-btn",
                      disabled: !_unref(selectedLines).length || busyKey.value === 'bulk',
                      onClick: removeSelected
                    }, " 선택삭제 ", 8, _hoisted_27),
                    (issueLines.value.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "mall-cart__ghost-btn",
                          disabled: busyKey.value === 'bulk',
                          onClick: removeIssues
                        }, " 품절·부족 삭제 ", 8, _hoisted_28))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lines), (line) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: line.key,
                      class: _normalizeClass(["mall-cart__item", {
                'is-issue': line.soldOut || line.stockShort || line.priceChanged,
                'is-editing': Boolean(optionEditors[line.key]),
              }])
                    }, [
                      _createElementVNode("label", _hoisted_30, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          checked: _unref(isSelected)(line.key),
                          onChange: ($event: any) => (_unref(toggle)(line.key))
                        }, null, 40, _hoisted_31),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "mall-cart__sr" }, "선택", -1))
                      ]),
                      _createVNode(_component_router_link, {
                        to: `/mall/${line.productId}`,
                        class: "mall-cart__thumb"
                      }, {
                        default: _withCtx(() => [
                          (line.product.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: line.product.image,
                                alt: line.product.name
                              }, null, 8, _hoisted_32))
                            : (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                _createVNode(AppIcon, {
                                  icon: "mdi-image-off-outline",
                                  size: 22
                                })
                              ]))
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_router_link, {
                            to: `/mall/${line.productId}`,
                            class: "mall-cart__name"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(line.product.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "mall-cart__remove",
                            "aria-label": "삭제",
                            disabled: busyKey.value === line.key,
                            onClick: ($event: any) => (onRemove(line.key))
                          }, [
                            _createVNode(AppIcon, {
                              icon: "mdi-close",
                              size: 18
                            })
                          ], 8, _hoisted_36)
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          (_unref(isOrderPack)(line.orderStep) && line.product.mallKind !== 'SALE')
                            ? (_openBlock(), _createBlock(MallOrderPackMark, {
                                key: 0,
                                size: "inline",
                                "order-step": line.orderStep,
                                "sell-unit": line.product.sellUnit
                              }, null, 8, ["order-step", "sell-unit"]))
                            : _createCommentVNode("", true),
                          (line.product.mallKind === 'SALE')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(Math.max(1, line.product.packQty || line.orderStep || 1)) + "개 묶음 ", 1))
                            : _createCommentVNode("", true),
                          (line.product.unit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(line.product.unit), 1))
                            : _createCommentVNode("", true),
                          (line.optionName)
                            ? (_openBlock(), _createElementBlock("em", _hoisted_40, [
                                _createTextVNode(" 옵션 · " + _toDisplayString(line.optionName) + " ", 1),
                                (line.optionExtra)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" (" + _toDisplayString(line.optionExtra > 0 ? '+' : '') + _toDisplayString(_unref(formatPrice)(line.optionExtra)) + "원) ", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (!line.soldOut)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                type: "button",
                                class: _normalizeClass(["mall-cart__opt-btn", { 'is-open': optionEditors[line.key] }]),
                                disabled: busyKey.value === line.key,
                                onClick: ($event: any) => (toggleOptionEditor(line))
                              }, _toDisplayString(optionEditors[line.key] ? '옵션 닫기' : '옵션 변경'), 11, _hoisted_41))
                            : _createCommentVNode("", true)
                        ]),
                        (optionEditors[line.key])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mall-cart__opt-title" }, "옵션 선택", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionEditors[line.key].groups, (group) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: `${line.key}-${group.name}`,
                                  class: "mall-cart__opt-row"
                                }, [
                                  _createElementVNode("label", {
                                    for: `cart-opt-${line.key}-${group.name}`
                                  }, _toDisplayString(group.name), 9, _hoisted_43),
                                  _withDirectives(_createElementVNode("select", {
                                    id: `cart-opt-${line.key}-${group.name}`,
                                    "onUpdate:modelValue": ($event: any) => ((optionEditors[line.key].selected[group.name]) = $event)
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: option.name,
                                        value: option.name
                                      }, [
                                        _createTextVNode(_toDisplayString(option.name) + " ", 1),
                                        (option.extra)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" (" + _toDisplayString(option.extra > 0 ? '+' : '') + _toDisplayString(_unref(formatPrice)(option.extra)) + "원) ", 1)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_45))
                                    }), 128))
                                  ], 8, _hoisted_44), [
                                    [_vModelSelect, optionEditors[line.key].selected[group.name]]
                                  ])
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "mall-cart__opt-cancel",
                                  disabled: busyKey.value === line.key,
                                  onClick: ($event: any) => (toggleOptionEditor(line))
                                }, " 취소 ", 8, _hoisted_47),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "mall-cart__opt-save",
                                  disabled: busyKey.value === line.key,
                                  onClick: ($event: any) => (saveOption(line.key))
                                }, " 적용 ", 8, _hoisted_48)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (line.soldOut)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_49, "품절된 상품입니다."))
                          : (line.stockShort)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_50, " 재고가 " + _toDisplayString(line.product.stock) + "개뿐입니다. 수량을 줄여 주세요. ", 1))
                            : (line.priceChanged)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_51, " 담을 때 " + _toDisplayString(_unref(formatPrice)(line.snapshotPrice || 0)) + "원 → 현재 " + _toDisplayString(_unref(formatPrice)(line.product.price)) + "원 ", 1))
                              : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(QtyStepper, {
                            class: "mall-cart__stepper",
                            "model-value": line.qty,
                            min: line.minOrder,
                            max: line.maxOrder,
                            step: line.orderStep,
                            unit: _unref(sellUnitNoun)(line.product.sellUnit),
                            carton: line.product.mallKind === 'SALE',
                            busy: busyKey.value === line.key,
                            disabled: line.soldOut,
                            "onUpdate:modelValue": ($event: any) => (onSetQty(line.key, $event))
                          }, null, 8, ["model-value", "min", "max", "step", "unit", "carton", "busy", "disabled", "onUpdate:modelValue"]),
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(line.lineTotal)) + "원", 1)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("aside", _hoisted_53, [
                _cache[19] || (_cache[19] = _createElementVNode("h2", null, "주문 요약", -1)),
                _createElementVNode("p", _hoisted_54, "선택상품 " + _toDisplayString(_unref(selectedLines).length) + "종", 1),
                _createElementVNode("dl", null, [
                  _createElementVNode("div", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("dt", null, "상품금액", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(selectedListSubtotal.value)) + "원", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("dt", null, "주문 배송비", -1)),
                    _createElementVNode("dd", null, _toDisplayString(selectedShippingLabel.value), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "결제예정금액", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(selectedPayable.value)) + "원", 1)
                ]),
                (canCheckoutSelected.value)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: "/mall/checkout",
                      class: "mall-cart__checkout",
                      onClick: _unref(clearBuyNowKeys)
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" 주문하기 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createElementBlock("button", _hoisted_56, _toDisplayString(checkoutDisabledLabel.value), 1)),
                _createVNode(_component_router_link, {
                  to: "/mall",
                  class: "mall-cart__continue"
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode("쇼핑계속하기", -1)
                  ]))]),
                  _: 1
                }),
                _createElementVNode("p", _hoisted_57, _toDisplayString(shippingNote.value), 1)
              ])
            ]))
    ]),
    (undoMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
          _createElementVNode("span", null, _toDisplayString(undoMessage.value), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: undoRemove
          }, "실행 취소")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})